module.exports = __webpack_public_path__ + "static/img/數量有限300.ed898c9c.png";